import "./LoginFormItemInput.scss";
import {Form, Input} from "antd";
import React from "react";

interface ILoginFormItemInputProps {
    name: string;
    label: string;
    rules: {required: boolean, message?: string};
    disabled?: boolean;
}

const LoginFormItemInput: React.FC<ILoginFormItemInputProps> = ({name, disabled, label, rules}) => {
    return (
        <Form.Item
            className={"login-form__item"}
            name={name}
            label={label}
            rules={[{required: rules.required, message: rules.message}]}
        >
        <Input
            className={"input"}
            disabled={disabled}
        />
        </Form.Item>
    )
}

export default LoginFormItemInput;